import Link from "next/link"
import React from "react"
import { withI18n } from "~/hocs"
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Modal,
  Form,
} from "react-bootstrap"
import { routes } from "~/router"
import { QRCodeCanvas } from "qrcode.react"

const DefectReport = ({
  t,
  formikDefect,
  video,
  showDefect,
  setShowDefect,
  handleCloseDefect,
  showSuccessDefect,
  isLoading,
}) => {
  return (
    <Modal show={showDefect} onHide={handleCloseDefect}>
      <Modal.Header closeButton>
        <Modal.Title>素材の不具合を報告する</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showSuccessDefect && (
          <Form
            noValidate
            onSubmit={formikDefect.handleSubmit}
            autoComplete="off"
            id="defectForm"
          >
            <div>
              <p>
                ご迷惑をおかけし誠に申し訳ございません。ファイルに不具合があった場合は内容を記入していただき、
                報告していただけますと幸いです。報告いただいたファイルについては当社で調査し対応させていただきます
                。正常なファイルを用意できた場合は再度アップいたしますが、できなかった場合は削除となる場合もございますこと
                、予めご了承ください。
              </p>
              <span>写真タイトル： {video.title}</span>
              <p>
                不具合のあるファイル
                <span className="ac-text-danger">※必須：</span>
              </p>
              <div className="mb-2">
                <Form.Check
                  type="radio"
                  label="MOV"
                  name="file_type"
                  value="MOV"
                  onChange={formikDefect.handleChange}
                />
                <Form.Check
                  type="radio"
                  label="MP4"
                  name="file_type"
                  value="MP4"
                  onChange={formikDefect.handleChange}
                />
                {formikDefect.errors.file_type &&
                  formikDefect.touched.file_type && (
                    <span className="ml-1 text-danger">
                      {formikDefect.errors.file_type}
                    </span>
                  )}
              </div>
              <div>
                <p>
                  不具合の内容<span className="ac-text-danger">※必須</span>
                </p>
                <Form.Group
                  className="mb-1"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    as="textarea"
                    name="detail"
                    rows={6}
                    placeholder="不具合の内容を入力..."
                    onChange={formikDefect.handleChange}
                  />
                </Form.Group>
                {formikDefect.errors.detail && formikDefect.touched.detail && (
                  <span className="ml-1 text-danger">
                    {formikDefect.errors.detail}
                  </span>
                )}
              </div>
              <Row>
                <Col xs={12} md={12} className="text-center mt-2">
                  <Button variant="primary" type="submit" disabled={isLoading}>
                    {isLoading && (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    送信
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        )}
        {showSuccessDefect &&
          "データが送信されました。ご協力ありがとうございました。"}
      </Modal.Body>
    </Modal>
  )
}

export default withI18n(DefectReport)
